<aside 
  class="sidebar"
  [class.collapsed]="collapsed()"
  [class.mobile]="isMobile()"
  [class.open]="mobileOpen()"
>
  @for (group of navigationGroups; track group.label) {
    <nav class="nav-group">
      <div class="nav-group-label">{{ group.label }}</div>
      <ul class="nav-list">
        @for (item of group.items; track item.label) {
          <li class="nav-item">
            @if (item.disabled) {
              <span
                class="nav-link disabled"
                [title]="item.label"
                aria-disabled="true"
              >
                @if (item.icon) {
                  <i [class]="item.icon"></i>
                }
                @if (!collapsed()) {
                  <span>{{ item.label }}</span>
                }
              </span>
            } @else {
              <a
                [routerLink]="item.route"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                class="nav-link"
                [attr.aria-current]="item.route ? 'page' : null"
                [title]="item.label"
              >
                @if (item.icon) {
                  <i [class]="item.icon"></i>
                }
                @if (!collapsed()) {
                  <span>{{ item.label }}</span>
                }
              </a>
            }
          </li>
        }
      </ul>
    </nav>
  }
</aside>
